import { INVESTMENT_OFFICES } from 'constants/globals';

import { defaultOfficeLabels } from './resources/default';
import { suraOfficeLabels } from './resources/sura';

export type OfficeLabels = typeof defaultOfficeLabels;

export const getOfficeLabelsByInvestmentOfficeId = (
  investmentOfficeId: string,
): OfficeLabels => {
  switch (investmentOfficeId) {
    case INVESTMENT_OFFICES.SURA:
      return suraOfficeLabels;
    default:
      return defaultOfficeLabels;
  }
};

export { defaultOfficeLabels, suraOfficeLabels };
